// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2pWbb","actionsCol":"EnrolledClinics_actionsCol__1Wkq6"};